import {baseDevConfig} from '../base/dev.config';
import {cbssportsLocalConfig} from './local.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cbssportsDevConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseDevConfig, cbssportsLocalConfig,  {
  environmentName: "Cbs Sports Development Environment",
  hubApi: "https://qa-cms.cbssports.com",
  ionicEnvName: 'dev',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cbssports/dev.config.ts